

import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import HelpCenterOutlined from '@mui/icons-material/HelpOutline';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import { IconButton, TextButton } from 'Components/Button';
import { Link, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form'
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { useRef, useState, useEffect } from "react";
import { PATHS } from "Utils/PagePaths";
import { ga_log_search } from "Utils/GA4/GTM";

function SearchButton ({ isSearchOpen, setIsSearchOpen }) {
    const loginInfo = useSelector(state => state.loginInfo);
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();
    var iconViewBox = "6.5 7 12 10";
    var searchInputRef = useRef(null);


    //const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isSearchBtnFocused, setIsSearchBtnFocused] = useState(false);
    const [isSearchInputFocused, setIsSearchInputFocused] = useState(false);
    const [searchText, setSearchText] = useState(null);

    const toggleSearchOpen = (e) => {
        setIsSearchOpen(!isSearchOpen);
    }

    const closeSearchOpen = () => {
        setIsSearchOpen(false);
    }

    const handleBlur = (e) => {
        //console.log(e);
        const currentTarget = e.currentTarget;
        const relatedTarget = e.relatedTarget;

        // Give browser time to focus the next element
        requestAnimationFrame(() => {
            // Check if the new focused element is a child of the original container
            if (!currentTarget.contains(document.activeElement)) {
                closeSearchOpen();

            }
        });
    };

    useEffect(() => {
        if (isSearchOpen == true) {
            //console.log(searchInputRef.current);
            searchInputRef.current.focus();
        }
        else {
            //console.log("searchclosed");
        }
    }, [isSearchOpen])


    const submitSearch = (e) => {
        if(searchText!=null && searchText.trim()!=''){
            ga_log_search(searchText);
            navigate(
                PATHS.public.Search,
                {
                    replace: true,
                    state:{
                        showResults: true,
                        searchText: searchText
                    }
                }
            )
        }
        else{
            navigate(
                PATHS.public.Search,
                {
                    replace: true,
                    state:{
                        showResults: false,
                        searchText: searchText
                    }
                }
            )
        }
    }

    return (
        isSearchOpen == true
        ?   
            <InputGroup id="searchInputHeader" onBlur={handleBlur} className="d-inline-flex align-items-center w-auto">
                <Form.Control 
                    type="text" 
                    id="searchField" 
                    role="searchbox" 
                    aria-label="Search Website" 
                    placeholder="Search" 
                    ref={searchInputRef} 
                    value={searchText} 
                    onChange={(e)=>{
                        setSearchText(e.target.value);
                    }}
                    onKeyDown={(e)=>{
                        //console.log(e);
                        if(e.key == "Enter"){
                            submitSearch(e);
                        }
                    }}
                />
                
                <IconButton 
                    id="searchButton2" 
                    onClick={submitSearch}
                    className="open" 
                    style={{ "backgroundColor": "#071E31" }}
                    icon={() => <SearchOutlined style={{ "color": "white" }}></SearchOutlined>} 
                >
                </IconButton>
            </InputGroup>
        : 
            <IconButton 
                style={{ "backgroundColor": "#071E31", "color": "white", "border": "none" }} 
                id="closedSearchButton" 
                onClick={toggleSearchOpen} 
                icon={() => <SearchOutlined></SearchOutlined>} 
            />
    );
}

export default SearchButton;